import { Button, withStyles } from "@material-ui/core";
import * as React from "react";
import { withTranslation } from 'react-i18next';
import { GoogleIcon, SamlIcon, AppleIcon, FacebookIcon, } from "components";
import { compose, pure, setDisplayName } from "recompose";
import { styles } from "./IdentityProvider.styles";
export var Render = function (_a) {
    var classes = _a.classes, url = _a.url, type = _a.type, t = _a.t;
    return React.createElement("div", { className: classes.root + ' auth-identityprovider' },
        React.createElement(Button, { href: url, style: {
                textTransform: 'none',
                fontWeight: 700,
                padding: '0 20px',
                width: '100%',
                height: 50,
                fontSize: 13,
                color: '#1B0406',
                borderRadius: 60,
                justifyContent: 'center',
                gap: 10
            } },
            type === "Google" ? React.createElement(GoogleIcon, null) : type === "Facebook" ? React.createElement(FacebookIcon, null) : type === "Apple" ? React.createElement(AppleIcon, null) : React.createElement(SamlIcon, null),
            t("continue_with"),
            " ",
            type));
};
export function enhance() {
    return compose(withTranslation(), withStyles(styles), pure, setDisplayName("IdentityProvider"));
}
export var IdentityProvider = enhance()(Render);
